import { memo } from 'react';
import { useInput } from 'utils/hooks';

import {
  Dialog,
  DialogFooter,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogClose
} from '@/shadcn/dialog';
import { Button } from '@/shadcn/button';
import { TestId } from '@/types/testId';
import { Input } from '@/shadcn/input';
import { Label } from '@/shadcn/label';

type Props = {
  isOpen: boolean;
  onOpenChange: (isOpen: boolean) => void;
  submit: (groupName: string) => void;
  workflowName: string;
};

// The modal to add a new group to a workflow
export const AddGroupModal = memo(
  ({ isOpen, onOpenChange, submit, workflowName }: Props) => {
    const [groupName, updateGroupName] = useInput('');

    return (
      <Dialog open={isOpen} onOpenChange={onOpenChange}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Create a new group</DialogTitle>
            <DialogDescription>
              Add a new group to{' '}
              <strong className="text-primary font-semibold">
                {workflowName}
              </strong>
              .
            </DialogDescription>
          </DialogHeader>

          <div className="grid w-full max-w-sm items-center gap-1.5">
            <Label htmlFor={TestId.WorkflowGroups.AddGroupModal.GroupNameInput}>
              Group Name
            </Label>
            <Input
              id={TestId.WorkflowGroups.AddGroupModal.GroupNameInput}
              autoFocus
              autoComplete="off"
              type="text"
              onChange={updateGroupName}
              value={groupName}
              data-testid={TestId.WorkflowGroups.AddGroupModal.GroupNameInput}
              placeholder="Group Name"
              className="bg-muted"
            />
          </div>
          <DialogFooter>
            <DialogClose asChild>
              <Button
                variant="outline"
                data-testId={TestId.WorkflowGroups.AddGroupModal.CancelButton}
              >
                Cancel
              </Button>
            </DialogClose>

            <Button
              onClick={() => submit(groupName)}
              disabled={!groupName}
              data-testid={TestId.WorkflowGroups.AddGroupModal.SubmitButton}
            >
              Create
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    );
  }
);
